import Checkout from './checkout.vue';

export default Checkout;
